var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "color-button-main" }, [
    _c(
      "div",
      {
        staticClass: "color-button-outer",
        class: _vm.active ? "color-button-active" : "",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.colorButtonClick($event)
          },
        },
      },
      [
        _c("div", {
          staticClass: "color-button-inner",
          class: "color-button-inner-" + _vm.colorType,
        }),
      ]
    ),
    _c("span", { staticClass: "text-area" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }